/*默认图片*/
let defaultImg = require("@/assets/img/default.png");

const DEFAULT_CONFIG = {
  //标题
  defaultImg,

  APP_ID: 10001,

  //版本号
  APP_VER: "1.6.9",

  //内核版本号
  CORE_VER: "1.6.9",
}

export default DEFAULT_CONFIG



// WEBPACK FOOTER //
// ./src/config/env.js